import { initials } from '@/utils/format';

export default function Avatar({ name, src, size }: { name: string; src?: string | null; size?: 'lg' }) {
  return <div className={`avatar ${size ?? ''}`}>{src ? <img src={src} alt={name} /> : initials(name)}</div>;
}
